import { deepCopy } from '..'
import IClient from '../../data_sources'
import {
  IImageStorage,
  STORED_IMAGE_PREFIX
} from '../../data_sources/imagestorage/imageStorage'
import { IPhoto } from '../../models/Checklist'
import { IIncident } from '../../models/Incident'
import { IUserCapabilities } from '../../models/User'
import { formatDate } from '../dates'

export async function submitIncident(
  client: IClient,
  capabilities: IUserCapabilities,
  franchiseeId: number,
  incident: IIncident,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  incidentChangeTracker: any,
  photos: IPhoto[],
  imageStorage: IImageStorage
): Promise<number> {
  const incidentData = deepCopy(incident)

  const customFields = incidentData.customFields || []

  // custom fields get sent in a seperate POST form field
  delete incidentData.customFields

  const incidentPostData: any = { incident: incidentData }
  if (incidentChangeTracker)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
    incidentPostData.incidentChangeTracker = incidentChangeTracker

  const incidentFormData = new FormData()
  incidentFormData.append('incident', JSON.stringify(incidentPostData))
  customFields.forEach((customField) => {
    incidentFormData.append('customFields[]', JSON.stringify(customField))
  })

  // Append incident photo data
  for (const photo of photos) {
    // Make sure it is a new (locally-stored) photo
    if (
      photo.attachmentType !== 'attachment' &&
      photo.url.startsWith(STORED_IMAGE_PREFIX)
    ) {
      const photoData = await imageStorage.getImageData(photo.url)

      let takenDate = photo.photoTakenDate || ''
      if (takenDate) {
        takenDate = formatDate('exif', takenDate)
      }
      incidentFormData.append('attachment[]', photoData, photo.fileName)
      incidentFormData.append(photo.fileName, photo.comment || '')
      incidentFormData.append(photo.fileName + 'photoTakenDate', takenDate)
    } else if (photo.attachmentType === 'attachment' && photo.uuid) {
      incidentFormData.append('attachmentTemp[]', photo.uuid)
      incidentFormData.append(photo.uuid, photo.comment || '')
    }
    //we can only change comments for existing photos/attachments
    else if (photo.id && photo.id > 0) {
      const photoCommentKey = 'ATTACHMENT_COMMENT_ID#' + String(photo.id)
      incidentFormData.append('attachmentComments[]', photoCommentKey)
      incidentFormData.append(photoCommentKey, photo.comment)
    }
  }

  console.log('Sending incident', incidentPostData)
  console.log('custom fields', customFields)
  const newIncidentId = await client.saveIncident(
    incidentFormData,
    incident.id,
    franchiseeId,
    capabilities.franchiseId
  )
  return newIncidentId
}
